/**
 * OnboardingStep3.tsx - Personal Interests
 * Personal interests step of the onboarding flow.
 * Allows users to select interests (multi-select chip interface).
 * Uses design system utilities for consistent styling.
 */

import InterestsEditor from "../preferences/editors/InterestsEditor";
import OnboardingStepHeader from "./common/OnboardingStepHeader";
import { View } from "react-native";
import { spacingStyles } from "../../../styles/design-system";

export interface OnboardingStep3Props {
  selectedInterests: string[];
  onInterestsChange: (interests: string[]) => void;
}

function OnboardingStep3({ selectedInterests, onInterestsChange }: OnboardingStep3Props) {
  return (
    <View style={spacingStyles.mNone}>
      <OnboardingStepHeader
        titleKey="companion_onboarding_step3_title"
        subtitleKey="companion_onboarding_step3_subtitle"
      />
      <InterestsEditor value={selectedInterests} onChange={onInterestsChange} />
    </View>
  );
}

export default OnboardingStep3;
